import { chatAction } from "../../store/action";
import store from "../../store";
import { Alert } from "modules/theme";
import { removeElementById } from "../../modules/screens/chatscreen/utils";

const compareByTimeStamp = (a, b) => {
  // Handle cases when timeStamp property is missing
  if (!a.message || !a.message.timeStamp) return -1;
  if (!b.message || !b.message.timeStamp) return 1;

  // Convert the timeStamp strings to Date objects and compare
  return new Date(b.message.timeStamp) - new Date(a.message.timeStamp);
};

export function createChatEvent(eventData) {
  const customEvent = new CustomEvent("custom-chat-event", {
    detail: eventData,
  });
  return customEvent;
}

export const changeLastMessage = ({
  list,
  identifier,
  receivedMessage,
  key,
}) => {
  list = list.map((item) => {
    if (identifier === item.identifier) {
      return { ...item, message: receivedMessage };
    }
    return item;
  });
  list.sort(compareByTimeStamp);
  store.dispatch(chatAction.dynamicUpdate({ data: { key: key, value: list } }));
};

export const changeLastAssistMessage = ({
  list,
  identifier,
  receivedMessage,
  key,
}) => {
  const existingList = list[identifier] || [];

  const updatedList = existingList.map((item) =>
    item.id === receivedMessage.id
      ? { ...item, message: receivedMessage }
      : item
  );

  updatedList.sort(compareByTimeStamp);

  store.dispatch(chatAction.dynamicUpdate({
    data: {
      key: `${key}.${identifier}`,
      value: updatedList
    }
  }));
};


export const getNotificationOption = (option) => {
  let options = {
    icon:
      "https://www.vkf-renzel.com/out/pictures/generated/product/1/356_356_75/r12044336-01/general-warning-sign-10836-1.jpg?    auto=compress&cs=tinysrgb&dpr=1&w=500",
    dir: "ltr",
  };
  return { ...options, ...option };
};

const getDisplayNumber = (identifier) => {
  const { assignedList } = store.getState().chatReducer;
  let currAssignedList = "";
  for (let i = 0; i < assignedList.length; i++) {
    if (identifier === assignedList.identifier) {
      currAssignedList = assignedList[i];
      break;
    }
  }
  if (
    currAssignedList &&
    currAssignedList.customer &&
    currAssignedList.customer.display
  ) {
    return currAssignedList.customer.display;
  }
  return "No Name";
};

export const playNotification = () => {
  // const audio = new Audio('/sound/notify.mp3');
  // audio.play();
};

export const renderNotification = ({ message, identifier }) => {
  let body = "";
  const messageType = message && message.type ? message.type : "";
  switch (messageType) {
    case "text":
      body = message.content.text;
      break;

    default:
      body = "Media received";
      break;
  }
  new Notification(
    getDisplayNumber(identifier),
    getNotificationOption({ body })
  );
};

const typingTimeouts = new Map();

const handleTypingEvent = (data) => {
  const uniqueIdentifier = data.data.identifier;

  if (data.data.eventMessage.type === "typing") {
    // Clear the existing timeout for this identifier if any
    if (typingTimeouts.has(uniqueIdentifier)) {
      clearTimeout(typingTimeouts.get(uniqueIdentifier));
    }

    store.dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: "typingIndicatorCus",
          value: true,
          identifier: uniqueIdentifier,
        },
      })
    );

    // Set a new timeout for 5 seconds
    const timeout = setTimeout(() => {
      store.dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "typingIndicatorCus",
            value: false,
            identifier: uniqueIdentifier,
          },
        })
      );
      typingTimeouts.delete(uniqueIdentifier);
    }, 5000);

    typingTimeouts.set(uniqueIdentifier, timeout);
  }

  if (data.data.payloadType === "message") {
    // Clear the typing timeout and reset the typing indicator for this identifier
    if (typingTimeouts.has(uniqueIdentifier)) {
      clearTimeout(typingTimeouts.get(uniqueIdentifier));
      typingTimeouts.delete(uniqueIdentifier);
    }

    store.dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: "typingIndicatorCus",
          value: false,
          identifier: uniqueIdentifier,
        },
      })
    );
  }
};

// export const receiveMessage = async ({ dispatch, data, getState }) => {
//   let typingTimeout;
//   if (data.data.eventMessage.type === "typing") {
//     dispatch(
//       chatAction.dynamicUpdate({
//         data: { key: "typingIndicatorCus", value: true },
//       })
//     );

//     clearTimeout(typingTimeout);

//     typingTimeout = setTimeout(() => {
//       dispatch(
//         chatAction.dynamicUpdate({
//           data: { key: "typingIndicatorCus", value: false },
//         })
//       );
//     }, 5000);
//   }

//   if (data.data.payloadType === "message") {
//     // Clear the typing timeout and reset the typing indicator
//     clearTimeout(typingTimeout);

//     dispatch(
//       chatAction.dynamicUpdate({
//         data: { key: "typingIndicatorCus", value: false },
//       })
//     );
//   }

//   // handleTypingEvent(data);

//   if (document.visibilityState === "hidden") {
//     playNotification();
//     renderNotification({
//       message: data.data.message,
//       identifier: data.data.identifier,
//     });
//   }

//   const chatEvent = createChatEvent({ msgAppended: true });
//   window.dispatchEvent(chatEvent);

//   const { messageList, assignedList } = getState().chatReducer;
//   changeLastMessage({
//     list: assignedList,
//     identifier: data.data.identifier,
//     receivedMessage: data.data.message,
//     key: "assignedList",
//   });
//   const msg = data.data;
//   dispatch(
//     chatAction.dynamicUpdate({
//       data: {
//         key: `messageList.${data.data.identifier}`,
//         value: [msg, ...(messageList[data.data.identifier] || [])],
//       },
//     })
//   );
// };
let typingTimeout;
export const receiveMessage = async ({ dispatch, data, getState }) => {

  const identifier = data.data.identifier;

  if (
    data &&
    data.data &&
    data.data.eventMessage &&
    data.data.eventMessage.type &&
    data.data.eventMessage.type === "typing"
  ) {
    dispatch(
      chatAction.dynamicUpdate({
        data: { key: `typingIndicatorCus.${identifier}`, value: true },
      })
    );

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    typingTimeout = setTimeout(() => {
      dispatch(
        chatAction.dynamicUpdate({
          data: { key: `typingIndicatorCus.${identifier}`, value: false },
        })
      );
    }, 5000);
    return
  }

  if (data.data.payloadType === "message") {
    // Clear the typing timeout and reset the typing indicator
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    dispatch(
      chatAction.dynamicUpdate({
        data: { key: `typingIndicatorCus.${identifier}`, value: false },
      })
    );
  }

  // handleTypingEvent(data);

  if (document.visibilityState === "hidden") {
    playNotification();
    renderNotification({
      message: data.data.message,
      identifier: data.data.identifier,
    });
  }

  const chatEvent = createChatEvent({ msgAppended: true });
  window.dispatchEvent(chatEvent);

  const { messageList, assignedList } = getState().chatReducer;
  changeLastMessage({
    list: assignedList,
    identifier: data.data.identifier,
    receivedMessage: data.data.message,
    key: "assignedList",
  });
  const msg = data.data;
  dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `messageList.${data.data.identifier}`,
        value: [msg, ...(messageList[data.data.identifier] || [])],
      },
    })
  );
};

let agentTypingTimeout;
// export const receiveAgentAssistMessage = async ({ dispatch, data, getState }) => {

//   const identifier = data.data.identifier;

//   store.dispatch(
//     chatAction.dynamicUpdate({
//       data: { key: `showAgentAssistMsg_${identifier}`, value: true }
//     })
//   )

//   if (
//     data &&
//     data.data &&
//     data.data.eventMessage &&
//     data.data.eventMessage.type &&
//     data.data.eventMessage.type === "typing"
//   ) {
//     dispatch(
//       chatAction.dynamicUpdate({
//         data: { key: `typingAssistCus.${identifier}`, value: true },
//       })
//     );

//     if (agentTypingTimeout) {
//       clearTimeout(agentTypingTimeout);
//     }

//     agentTypingTimeout = setTimeout(() => {
//       dispatch(
//         chatAction.dynamicUpdate({
//           data: { key: `typingAssistCus.${identifier}`, value: false },
//         })
//       );
//     }, 5000);
//     return
//   }

//   if (data.data.payloadType === "message") {
//     // Clear the typing timeout and reset the typing indicator
//     if (agentTypingTimeout) {
//       clearTimeout(agentTypingTimeout);
//     }

//     dispatch(
//       chatAction.dynamicUpdate({
//         data: { key: `typingAssistCus.${identifier}`, value: false },
//       })
//     );
//   }

//   // handleTypingEvent(data);

//   // if (document.visibilityState === "hidden") {
//   //   playNotification();
//   //   renderNotification({
//   //     message: data.data.message,
//   //     identifier: data.data.identifier,
//   //   });
//   // }

//   const chatEvent = createChatEvent({ msgAppended: true });
//   window.dispatchEvent(chatEvent);

//   const msg = data.data;
//   dispatch(
//     chatAction.dynamicUpdate({
//       data: {
//         key: `assistMessageList.${data.data.identifier}`,
//         value: [msg, ...(assistMessageList[data.data.identifier] || [])],
//       },
//     })
//   );
// };

export const receiveAgentAssistMessage = async ({ dispatch, data, getState }) => {
  const identifier = data.data.identifier;
  const sessionId = data.data.sessionId;
  const message = data.data.message;

  // Show the textarea and messages
  store.dispatch(
    chatAction.dynamicUpdate({
      data: { key: `showAgentAssistMsg_${identifier}`, value: true }
    })
  );

  // Optionally handle typing events
  if (data &&
    data.data &&
    data.data.eventMessage &&
    data.data.eventMessage.type &&
    data.data.eventMessage.type === "typing") {
    dispatch(chatAction.dynamicUpdate({
      data: { key: `typingAssistCus.${identifier}`, value: true },
    }));

    if (agentTypingTimeout) clearTimeout(agentTypingTimeout);

    agentTypingTimeout = setTimeout(() => {
      dispatch(chatAction.dynamicUpdate({
        data: { key: `typingAssistCus.${identifier}`, value: false },
      }));
    }, 5000);

    return;
  }

  if (data.data.payloadType === "message") {
    if (agentTypingTimeout) clearTimeout(agentTypingTimeout);

    dispatch(chatAction.dynamicUpdate({
      data: { key: `typingAssistCus.${identifier}`, value: false },
    }));

    const { assistMessageList } = getState().chatReducer;

    const existing = assistMessageList[identifier] || [];

    const updated = [data.data, ...existing];

    // Update the message list
    dispatch(chatAction.dynamicUpdate({
      data: {
        key: `assistMessageList.${identifier}`,
        value: updated,
      },
    }));

    // Update the last message in assist list
    changeLastAssistMessage({
      list: assistMessageList,
      identifier,
      receivedMessage: message,
      key: "assistMessageList",
    });

    const chatEvent = createChatEvent({ msgAppended: true });
    window.dispatchEvent(chatEvent);
  }
};


const isAlreadyInList = ({ list, identifier }) => {
  for (let i = 0; i < list.length; i++) {
    if (list[i].identifier === identifier) {
      return true;
    }
  }
  return false;
};

export const addNewCustomer = ({ dispatch, list, data, getState }) => {
  const { details, messageList } = getState().chatReducer;
  if (isAlreadyInList({ list, identifier: data.data.identifier })) {
    changeLastMessage({
      list,
      identifier: data.data.identifier,
      receivedMessage: data.data.message,
      key: "unAssignedList",
    });
    const msg = data.data;
    dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: `messageList.${data.data.identifier}`,
          value: [msg, ...(messageList[data.data.identifier] || [])],
        },
      })
    );
  } else {
    if (document.visibilityState === "hidden") {
      // playNotification();
      // new Notification("New customer arrived.", getNotificationOption());
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then(function (registration) {
          if (registration) {
            registration.showNotification(`${data && data.data && data.data.customer && data.data.customer.display ? data.data.customer.display : "New Customer"} joined the queue.`, getNotificationOption());
          }
        });
      }
    }
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "unAssignedList", value: [data.data, ...list] },
      })
    );
    if (details.assignScreen === true) {
      const count = (details && details.newUnAssignedUsers + 1) || 0;
      store.dispatch(
        chatAction.dynamicUpdate({
          data: { key: "details.newUnAssignedUsers", value: count },
        })
      );
    }
  }
};

export const resolveCustomer = ({ identifier, list, data, messageList, getState }) => {
  const { disposeList, unAssignedList, selectedAssignedList } = getState().chatReducer;
  const status = (data &&
    data.data &&
    data.data.eventMessage &&
    data.data.eventMessage.status) ||
    false;
  let newList = [];
  if (status) {
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: `solveLoading_${identifier}`, value: false }
      })
    )
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "disposeScreen", value: true },
      })
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "activeTab", value: "dispose" },
      })
    );
    // let newMessageList = messageList
    // delete messageList[identifier];
    newList = list.filter((item) => item.identifier !== identifier);
    //   chatAction.clearChatAgentAssist({ identifier: messageList[identifier] })
    // );

    const resolvedCustomer = list.filter(
      (item) => item.identifier === identifier
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "disposeList", value: [...resolvedCustomer, ...disposeList] }
      })
    )
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "assignedList", value: newList },
      })
    );

    if (selectedAssignedList && selectedAssignedList.sessionId) {
      const isSelectedInUnassigned = unAssignedList.some(
        (item) => item.sessionId === selectedAssignedList.sessionId
      );

      if (isSelectedInUnassigned) {
        store.dispatch(
          chatAction.dynamicUpdate({
            data: { key: "selectedAssignedList", value: {} },
          })
        );
      }
    }
    const newUnassignedList = removeElementById(
      unAssignedList,
      "identifier",
      data.data.identifier
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: "unAssignedList",
          value: newUnassignedList,
        },
      })
    );
    const msg = data.data;
    store.dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: `messageList.${data.data.identifier}`,
          value: [msg, ...(messageList[data.data.identifier] || [])],
        },
      })
    );
    // store.dispatch(
    //   chatAction.dynamicUpdate({
    //     data: { key: "messageList", value: messageList },
    //   })
    // );
    // Alert.success("Customer resolved successfully.");
  } else {
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: `solveLoading_${identifier}`, value: false }
      })
    )
    if (data.data.eventMessage.uiAction === 'alertOnly') {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "alertAndAction") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "actionOnly") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "alertAndRemove") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
      const { assignedList } = getState().chatReducer;
      const newUnassignedList = removeElementById(
        assignedList,
        "identifier",
        data.data.identifier
      );
      store.dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "assignedList",
            value: newUnassignedList,
          },
        })
      );
    } else if (data.data.eventMessage.uiAction === "alertAndAdd") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else {
      Alert.error("Error occurred during resolving customer.");
    }
  }
};

export const disposeCustomer = ({ identifier, list, data, messageList, getState }) => {
  const status =
    (data &&
      data.data &&
      data.data.eventMessage &&
      data.data.eventMessage.status) ||
    false;
  let newList = [];
  if (status) {
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: `doneLoading_${identifier}`, value: false }
      })
    )
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "disposeScreen", value: false },
      })
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "activeTab", value: "reply" },
      })
    );
    let newMessageList = messageList
    delete messageList[identifier];
    newList = list.filter((item) => item.identifier !== identifier);
    // store.dispatch(
    //   chatAction.clearChatAgentAssist({ identifier: messageList[identifier] })
    // );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "disposeList", value: newList },
      })
    );


    // dynamicUpdate({
    //   data: { key: "unAssignedList", value: newUnassignedList },
    // });
    // const newAssignedList = removeElementById(
    //   assignedList,
    //   "identifier",
    //   data.data.identifier
    // );
    // dispatch(
    //   chatAction.dynamicUpdate({
    //     data: {
    //       key: "assignedList",
    //       value: [data.data, ...newAssignedList],
    //     },
    //   })
    // );


    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "selectedAssignedList", value: {} },
      })
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: "messageList", value: messageList },
      })
    );
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: `messageSelectedTag_${newList.sessionId}`, value: [] },
      })
    );
    // store.dispatch(
    //   chatAction.dynamicUpdate({
    //     data: { key: "messageSelectedTag", value: [] },
    //   })
    // );

    Alert.success("Customer resolved successfully.");
  } else {
    store.dispatch(
      chatAction.dynamicUpdate({
        data: { key: `doneLoading_${identifier}`, value: false }
      })
    )
    if (data.data.eventMessage.uiAction === 'alertOnly') {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "alertAndAction") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "actionOnly") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else if (data.data.eventMessage.uiAction === "alertAndRemove") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
      const { disposeList } = getState().chatReducer;
      const newUnassignedList = removeElementById(
        disposeList,
        "identifier",
        data.data.identifier
      );
      store.dispatch(
        chatAction.dynamicUpdate({
          data: {
            key: "disposeList",
            value: newUnassignedList,
          },
        })
      );
    } else if (data.data.eventMessage.uiAction === "alertAndAdd") {
      Alert.error(data && data.data && data.data.message && data.data.message.content && data.data.message.content.text ? data.data.message.content.text : "Something went wrong happen.")
    } else {
      Alert.error("Error occurred during resolving customer.");
    }
  }
}

const promiseWrapper = (fn) => {
  const promise = new Promise((resolve, reject) => {
    fn();
    resolve();
  });
  return promise;
};

export const getHumanReadableDate = (isoDate) => {
  const dateObject = new Date(isoDate);
  const formattedTime = dateObject.toLocaleString("en-US", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  });
  return formattedTime;
};

export const getHistory = ({
  messageList,
  selectedAssignedList,
  paginationInfo,
  data,
}) => {
  // const chatEvent = createChatEvent({ msgPrepended: true })

  let newMessageList = [];
  let identifier = "";
  if (
    data &&
    data.responce &&
    data.responce.data &&
    Array.isArray(data.responce.data) &&
    data.responce.data.length > 0
  ) {
    newMessageList = data.responce.data;
    // newMessageList = data.responce.data.map(e => {
    //   const msg = e.message
    //   return {
    //     ...msg,
    //     // timeStamp: getHumanReadableDate(msg.timeStamp),
    //   }
    // })
    // }).sort(() => -1)
    identifier = data.responce.data[0].identifier;
  }
  if (!identifier) {
    store.dispatch(
      chatAction.dynamicUpdate({
        data: {
          key: `selectedAssignedList`,
          value: { ...selectedAssignedList, loading: false },
        },
      })
    );
    return;
  }
  const count = data && data.responce && data.responce.count;
  store.dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `paginationInfo.${identifier}`,
        value: { ...(paginationInfo[identifier] || {}), count },
      },
    })
  );
  store.dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `messageList.${identifier}`,
        value: [...(messageList[identifier] || []), ...newMessageList],
      },
    })
  );
  store.dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `selectedAssignedList`,
        value: { ...selectedAssignedList, loading: false },
      },
    })
  );
  store.dispatch(
    chatAction.dynamicUpdate({
      data: { key: `mainScreenLoading`, value: true },
    })
  );
  // window.dispatchEvent(chatEvent)
};

export const getAssistHistory = ({
  assistMessageList,
  selectedAssignedList,
  assistPaginationInfo,
  data,
}) => {

  let newMessageList = [];
  let identifier = "";
  if (
    data &&
    data.responce &&
    data.responce.data &&
    Array.isArray(data.responce.data) &&
    data.responce.data.length > 0
  ) {
    newMessageList = data.responce.data;
    identifier = data.responce.data[0].identifier;
  }
  // if (!identifier) {
  //   store.dispatch(
  //     chatAction.dynamicUpdate({
  //       data: {
  //         key: `selectedAssignedList`,
  //         value: { ...selectedAssignedList, loading: false },
  //       },
  //     })
  //   );
  //   return;
  // }
  const count = data && data.responce && data.responce.count;
  store.dispatch(
    chatAction.dynamicUpdate({
      data: { key: `showAgentAssistMsg_${identifier}`, value: true }
    })
  );
  store.dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `assistPaginationInfo.${identifier}`,
        value: { ...(assistPaginationInfo[identifier] || {}), count },
      },
    })
  );
  store.dispatch(
    chatAction.dynamicUpdate({
      data: {
        key: `assistMessageList.${identifier}`,
        value: [...(assistPaginationInfo[identifier] || []), ...newMessageList],
      },
    })
  );
  // store.dispatch(
  //   chatAction.dynamicUpdate({
  //     data: {
  //       key: `selectedAssignedList`,
  //       value: { ...selectedAssignedList, loading: false },
  //     },
  //   })
  // );
  // store.dispatch(
  //   chatAction.dynamicUpdate({
  //     data: { key: `mainScreenLoading`, value: true },
  //   })
  // );
  // window.dispatchEvent(chatEvent)
};



// WEBPACK FOOTER //
// src/dialpad/service/chat.service.js